"use strict";
// Only generic validation should be placed here
exports.__esModule = true;
exports.hasNonNumericCharacters = exports.matchesCaseInsensitive = exports.matches = exports.hasFewerCharactersThan = exports.hasMoreLettersThan = exports.hasMoreDigitsThan = exports.hasLength = exports.hasMoreCharactersThan = void 0;
var NON_LETTERS = /\W|\d|_/g;
var NON_DIGITS = /\D/g;
function hasMoreCharactersThan(limit, value) {
    return value.length > limit;
}
exports.hasMoreCharactersThan = hasMoreCharactersThan;
function hasLength(value) {
    return hasMoreCharactersThan(0, value);
}
exports.hasLength = hasLength;
function hasMoreDigitsThan(limit, value) {
    return value.replace(NON_DIGITS, '').length > limit;
}
exports.hasMoreDigitsThan = hasMoreDigitsThan;
function hasMoreLettersThan(limit, value) {
    return value.replace(NON_LETTERS, '').length > limit;
}
exports.hasMoreLettersThan = hasMoreLettersThan;
function hasFewerCharactersThan(limit, value) {
    return value.length < limit;
}
exports.hasFewerCharactersThan = hasFewerCharactersThan;
function matches(a, b) {
    return a === b;
}
exports.matches = matches;
function matchesCaseInsensitive(a, b) {
    return matches(a.toLowerCase(), b.toLowerCase());
}
exports.matchesCaseInsensitive = matchesCaseInsensitive;
function hasNonNumericCharacters(value) {
    return value.match(NON_DIGITS) != null;
}
exports.hasNonNumericCharacters = hasNonNumericCharacters;
//# sourceMappingURL=generic.js.map